<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row>
      <v-col>
        <span class="text-tcdc-green header bold">FAQS</span>
      </v-col>
    </v-row>
    <v-tabs v-model="tab" color="#2e8037">
      <v-tab v-for="(item, index) in tabs" :key="index.toString()">
        <span class="sub-header1 bold">{{item.category}}</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in tabs" :key="index.toString()">
        <v-row>
          <v-col>
            <FaqsExpandable :items="faqs.filter(q => q.category_id === item.id)" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import FaqsExpandable from "../../components/expandables/FaqsExpandable";
import { mapState } from 'vuex';

export default {
  components: {
    FaqsExpandable
  },
  async created() {
    this.items[0].text = this.branchName;
    let path;
    for (const b of this.allBranches) {
      if (this.branchId === b.branch_id) {
        if (this.branchId === 0) {
          path = `/home`;
          break;
        }
        path = `/home/${b.tag_name}`;
        break;
      }
    }
    this.items[0].to = path;
    // if (!this.faqs) {
      await this.$store.dispatch('Faq/onGetAllFaqs', this.lang);
    // }
    let exist = [];
    for (const item of this.faqs) {
      if (!exist.includes(item.category_id)) {
        exist.push(item.category_id);
        this.tabs.push({ id: item.category_id, category: item.category_name });
      }
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      faqs: state => state.Faq.faqs
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
      let path;
      for (const b of this.allBranches) {
        if (this.branchId === b.branch_id) {
          if (this.branchId === 0) {
            path = `/home`;
            break;
          }
          path = `/home/${b.tag_name}`;
          break;
        }
      }
      this.items[0].to = path;
    }
  },
  data: () => ({
    tab: "1", // initial
    tabs: [
      // { name: "about member", value: "1" },
      // { name: "about library", value: "2" }
    ],
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home/:branch"
      },
      {
        text: "PROGRAM",
        to: "/:branch/home"
      }
    ]
  })
};
</script>

<style>
</style>
